module.exports = __webpack_public_path__ + "static/media/bet_1.3c629b55.mp3";